import { BookingsApi, Configuration } from '@/openapi'
import { useAuthStore } from '@/store/auth'

const configuration = new Configuration({
  basePath: `${import.meta.env.VITE_API_BASE_URL}/bookings`,
  middleware: [
    {
      pre: async ctx => {
        const auth = useAuthStore()
        const organizationId = auth.organizationId
        const bookingLocationId = auth.locationId
        if (organizationId) {
          ctx.init.headers = {
            ...ctx.init.headers,
            'Organization-ID': organizationId
          }
        }
        if (bookingLocationId) {
          ctx.init.headers = {
            ...ctx.init.headers,
            'Location-ID': bookingLocationId
          }
        }
        return ctx
      }
    }
  ]
})

export const bookingsApi = new BookingsApi(configuration)
